package com.ives.components.gridpopup;

import js.html.Element;
import js.html.SpanElement;
import js.Browser;
import js.html.DivElement;

import com.er453r.hxcompo.Component;

import com.ives.components.popup.Popup;

class GridPopup extends Component{
	private static inline var ROWS_ATTR:String = "data-rows";
	private static inline var COLS_ATTR:String = "data-cols";
	private static inline var ROWS:UInt = 4;
	private static inline var COLS:UInt = 4;

	private var buttons:Array<Element> = [];

	public function new(){
		on(closeButton, "click", close);

		for(row in 1...ROWS + 1){
			var div:DivElement = Browser.document.createDivElement();

			for(column in 1...COLS + 1){
				var button:DivElement = Browser.document.createDivElement();
				var span:SpanElement = Browser.document.createSpanElement();

				span.innerHTML = '${row}x${column}';

				button.setAttribute(ROWS_ATTR, Std.string(row));
				button.setAttribute(COLS_ATTR, Std.string(column));
				button.appendChild(span);
				button.className = "button gridButton";
				div.appendChild(button);

				buttons.push(button);
			}

			append(div);
		}

		on(".gridButton", "click", onButtonClick);
		on(".gridButton", "mouseover", onButtonOver);
	}

	private function onButtonClick(element:Element){
		dispatch("grid", [Std.parseInt(element.getAttribute(COLS_ATTR)), Std.parseInt(element.getAttribute(ROWS_ATTR))]);

		close();
	}

	private function onButtonOver(element:Element){
		var row:UInt = Std.parseInt(element.getAttribute(ROWS_ATTR));
		var col:UInt = Std.parseInt(element.getAttribute(COLS_ATTR));

		for(button in buttons){
			var buttonRow:UInt = Std.parseInt(button.getAttribute(ROWS_ATTR));
			var buttonCol:UInt = Std.parseInt(button.getAttribute(COLS_ATTR));

			if(buttonRow <= row && buttonCol <= col)
				button.classList.add("in-layout");
			else
				button.classList.remove("in-layout");
		}
	}

	private function close(){
		dispatch(Popup.CLOSE);
	}

	public function open(){
		new Popup(this).open("#viewer");
	}
}
